<template functional>
  <div class="active-courses">
    <div class="active-courses__header">
      <div class="active-courses__header--title">Course Name</div>
      <div class="active-courses__header--instructor">Instructor</div>
      <div class="active-courses__header--toggle">Remove</div>
    </div>
    <div
      v-for="course in props.courses"
      :key="course.id"
      class="active-courses__courses-wrapper"
    >
      <div class="active-courses__course">
        <div class="active-courses__course--title">{{ course.title }}</div>
        <div class="active-courses__course--instructor">
          {{ course.presenter.full_name }}
        </div>
        <div class="active-courses__course--remove">
          <button
            @click="listeners['removeActiveCourse'](course)"
            class="material-icons active-courses__course--remove--icon"
          >
            delete
          </button>
        </div>
        <div class="active-courses__course--link-container">
          <router-link
            :to="{
              name: 'course',
              params: { id: course.id, slug: course.slug },
            }"
            class="active-courses__course--link-container--link"
            >Resume</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDashboardActiveCourses',
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.active-courses {
  @include tablet {
    padding: 0 10px;
  }
  &__header {
    display: none;
    @include mobile {
      display: flex;
      color: var(--gray);
      text-transform: uppercase;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    &--title {
      width: 50%;
    }
    &--instructor {
      width: 25%;
    }
    &--toggle {
      width: 25%;
    }
  }
  &__course {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    @include mobile {
      padding: 20px 0px;
    }
    &--title {
      color: var(--white);
      font-size: 1rem;
      width: 50%;
      padding: 0 25px 0 0;
    }
    &--instructor {
      display: none;
      width: 25%;
      @include mobile {
        display: block;
        color: var(--white);
      }
    }
    &--remove {
      width: 12.5%;
      &--icon {
        color: var(--white);
        font-size: (24 / 16) * 1rem;
        border: none;
        background: none;
        cursor: pointer;
        transition: color 0.2s ease-out;
        &:hover {
          color: var(--red);
        }
      }
    }
    &--link-container {
      display: flex;
      align-items: center;
      width: auto;
      @include tablet {
        width: 12.5%;
      }
      &--link {
        border: 1px solid var(--white);
        border-radius: 25px;
        padding: 5px 15px;
        color: var(--white);
        text-transform: uppercase;
        text-align: center;
        transition: 0.5s all ease;
        &:hover {
          background-color: var(--white);
          color: var(--black);
        }
      }
    }
  }
}
</style>
